import { render, staticRenderFns } from "./ButtonChangeCustomer.vue?vue&type=template&id=b33cb91e&"
import script from "./ButtonChangeCustomer.vue?vue&type=script&lang=js&"
export * from "./ButtonChangeCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports